import { COLOR_PALETTE } from 'constants/ui';

export const startAdornmentStyles = {
  maxHeight: 'unset',
  height: '100%',
  marginRight: 0,
  borderRadius: ({ shape }) => `${shape.radius.l} 0 0 ${shape.radius.l}`,
  borderRight: ({ palette }) => `1px solid ${palette.border.input}`,
};

export const endAdornmentStyles = {
  maxHeight: 'unset',
  height: '100%',
  marginRight: 0,
  borderRadius: ({ shape }) => `0px ${shape.radius.l} ${shape.radius.l} 0px`,
  borderLeft: ({ palette }) => `1px solid ${palette.border.input}`,
};

export const getAdornmentSignStyles = ({ isSmall }) => ({
  padding: isSmall ? '0 11.5px' : '0 15.5px',
  color: ({ palette }) => `${palette.text.secondary} !important`,
});

export const inputStyles = {
  padding: 0,

  '.input-adornment': {
    borderColor: ({ palette }) => palette.border.input,
  },

  '&:hover .input-adornment': {
    borderColor: ({ palette }) => palette.border.inputHover,
  },

  '&.Mui-focused .input-adornment': {
    borderColor: COLOR_PALETTE.BRAND[6],
  },

  '&[data-is-changed="true"]:not(.Mui-error)': {
    '.input-adornment, &.Mui-focused .input-adornment': {
      borderColor: COLOR_PALETTE.ORANGE[7],
    },

    '&:hover:not(.Mui-focused) .input-adornment': {
      borderColor: COLOR_PALETTE.ORANGE[6],
    },
  },

  '&.Mui-error': {
    '.input-adornment, &.Mui-focused .input-adornment': {
      borderColor: ({ palette }) => palette.text.error,
    },

    '&:hover .input-adornment': {
      borderColor: COLOR_PALETTE.RED[6],
    },
  },

  '&.Mui-disabled .input-adornment': {
    backgroundColor: ({ palette }) => palette.background.disabled,
    borderColor: ({ palette }) => palette.border.input,
  },
};

export const maskIconStyles = {
  padding: 0,
};

export const flagsStyles = {
  width: '100%',
  height: '100%',
  padding: '0 11px 0 13px',
};
